import type { FC } from "react";

import { MDSButton, MDSButtonVariant, MDSCardSlotName } from "@/mds";

import { ActionsRow, CardContainer, ModalCard } from "./shared";

interface InviteStatusViewProps {
  title: string;
  description?: string | null;
  onAction?: () => void;
}

export const InviteStatusView: FC<InviteStatusViewProps> = ({ title, description, onAction }) => (
  <CardContainer>
    <ModalCard title={title} description={description ?? undefined}>
      {onAction ? (
        <div slot={MDSCardSlotName.Content}>
          <ActionsRow>
            <MDSButton variant={MDSButtonVariant.Contrast} onPress={onAction}>
              Close
            </MDSButton>
          </ActionsRow>
        </div>
      ) : null}
    </ModalCard>
  </CardContainer>
);
